import { ICPLAuthUserMigrationClient } from "services/api/cplauthapi/CPLAuthAPI";
import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IUserMigrationService {
  migrateAllCoreAccounts(): Promise<string[]>;
  resendUserInvitations(): Promise<void>;
}

@injectable()
export class UserMigrationService implements IUserMigrationService {
  @inject(SERVICE_TYPES.CPLAuthUserMigrationClient) cplAuthUserMigrationClient!: ICPLAuthUserMigrationClient;

  migrateAllCoreAccounts(): Promise<string[]> {
    return this.cplAuthUserMigrationClient.migrateAllCoreAccounts();
  }

  async resendUserInvitations(): Promise<void> {
    return this.cplAuthUserMigrationClient.resendUserInvitiations();
  }
}
